module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="filters__title">Filter</div>\n\n<div class="filter">\n	<div class="filters__intro">'+
((__t=( getFilterTitle() ))==null?'':__t)+
' </div>\n	<!-- Begin Filters list -->\n	<span class="filters__list-region"></span>\n	<!-- End Filters list -->\n	<span class="filter-add__region"></span>\n\n\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/devices-filter/templates/layout.html
// module id = 406
// module chunks = 0